//
//
//
//
//
//
//
//
//
//
import * as THREE from 'three'; // 鼠标控制器
// import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
// import { Geometry } from 'three/examples/jsm/deprecated/Geometry'

var timer = null;
export default {
  name: 'earth',
  // props:['width'],
  data: function data() {
    return {
      // 创建一个场景
      scene: null,
      // 创建一个相机
      camera: null,
      // 创建一个渲染器
      renderer: null,
      radius: 250,
      // 地球半径
      orbit: null,
      earthMesh: null,
      width: 0,
      height: 0,
      areas: [{
        name: '雅安',
        position: [103.049, 30.016]
      }],
      hexagon: null,
      isAnimation: true,
      isRotate: true,
      showEarth: true,
      properties: {
        size: {
          name: 'size',
          value: 9,
          min: 0,
          max: 20,
          step: 0.1
        },
        opacity: {
          name: 'opacity',
          value: 0.6,
          min: 0,
          max: 1,
          step: 0.1
        },
        transparent: true,
        vertexColors: true,
        sizeAttenuation: true,
        rotateSystem: true,
        color: '#ccffcc'
      },
      isShowColors: false,
      points: null,
      deg: 0,
      zValue: 0,
      flag: true
    };
  },
  watch: {
    showEarth: function showEarth(val) {
      if (!val) {
        clearInterval(timer);
        window.removeEventListener('resize', this.onResize, false);
      }
    }
  },
  mounted: function mounted() {
    if (localStorage.getItem('showEarth') == 'false') {
      this.flag = false;
    } else {
      this.flag = true;
    } // 监听窗体调整大小事件


    console.log('高度：', document.querySelector('.mapContent').clientHeight);
    this.width = this.width || document.querySelector('.mapContent').clientWidth;
    this.height = document.querySelector('.mapContent').clientHeight;
    this.init(); // 监听窗体调整大小事件

    window.addEventListener('resize', this.onResize, false);
  },
  methods: {
    init: function init() {
      // 创建一个场景，它将包含我们所有的元素，如物体，相机和灯光。
      this.scene = new THREE.Scene(); // 创建一个摄像机，它定义了我们正在看的地方

      this.camera = new THREE.PerspectiveCamera(70, this.width / this.height, 1, 10000); // 将摄像机对准场景的中心

      this.camera.position.set(50, 0, 700);
      this.camera.lookAt(this.scene.position); // this.camera.lookAt(0, 0, 0)
      // this.orbit = new OrbitControls(this.camera)
      // 创建一个渲染器并设置大小，WebGLRenderer将会使用电脑显卡来渲染场景

      this.renderer = new THREE.WebGLRenderer({
        antialias: true,
        logarithmicDepthBuffer: true
      });
      this.renderer.setSize(this.width, this.height); // scene.add(new THREE.AmbientLight(0x666666));

      var ambientLight = new THREE.AmbientLight('#ffffff', 1);
      this.scene.add(ambientLight);
      this.createEarth();
      this.createAreaPoint(); // 将呈现器的输出添加到HTML元素

      document.getElementById('dom').appendChild(this.renderer.domElement); // 启动动画

      this.renderScene(); // 渲染的场景

      this.renderer.render(this.scene, this.camera);
      this.createParticles(); // 创建粒子系统
    },
    // 创建粒子系统
    createParticles: function createParticles() {
      // 创建粒子材质
      var material = new THREE.SpriteMaterial({
        map: new THREE.TextureLoader().load(require("../../assets/others/index/star2.png")),
        color: 0xffffff
      });
      material.rotation = Math.PI;
      var range = 1000;

      for (var i = 0; i < 3000; i++) {
        var sprite = new THREE.Sprite(material);
        sprite.position.set(Math.random() * range - range / 2, Math.random() * range - range / 2, Math.random() * range - range / 2);
        sprite.scale.set(4, 4, 4);
        this.scene.add(sprite);
      }
    },
    onResize: function onResize() {
      this.width = document.querySelector('.mapContent').clientWidth;
      this.height = document.querySelector('.mapContent').clientHeight;
      this.camera.aspect = this.width / this.height;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize(this.width, this.height);
    },
    // 世界坐标转屏幕坐标
    coordinateWorldTurnScreen: function coordinateWorldTurnScreen(x, y, z) {
      var world_vector = new THREE.Vector3(x, y, z);
      var vector = world_vector.project(this.camera);
      var halfWidth = this.width / 2,
          halfHeight = this.height / 2;
      return {
        x: Math.round(vector.x * halfWidth + halfWidth),
        y: Math.round(-vector.y * halfHeight + halfHeight)
      };
    },
    // 创建地球 半径150
    createEarth: function createEarth() {
      var earthGeo = new THREE.SphereGeometry(this.radius, 50, 50);
      var earthMater = new THREE.MeshPhongMaterial({
        map: new THREE.TextureLoader().load(require("../../assets/others/index/earth1.png")),
        transparent: false // depthWrite: false,
        // side: THREE.DoubleSide,
        // blending: THREE.AdditiveBlending,
        // opacity: 1,
        // color: 0x03d98e

      });
      this.earthMesh = new THREE.Mesh(earthGeo, earthMater);
      this.scene.add(this.earthMesh);
    },
    createAreaPoint: function createAreaPoint() {
      // 球面
      var sphereGeom = new THREE.SphereGeometry(1, 20, 20),
          sphereMat = new THREE.MeshBasicMaterial({
        // color: 0x03d98e,
        wireframe: true
      });
      var sphere = new THREE.Mesh(sphereGeom, sphereMat);
      this.scene.add(sphere); // 地标及光锥

      for (var i = 0, length = this.areas.length; i < length; i++) {
        var position = this.createPosition(this.areas[i].position); // this.createHexagon(position) // 地标
      }
    },
    // 坐标转换
    createPosition: function createPosition(lnglat) {
      var spherical = new THREE.Spherical();
      spherical.radius = this.radius;
      var lng = lnglat[0];
      var lat = lnglat[1];
      var theta = (lng + 90) * (Math.PI / 180);
      var phi = (90 - lat) * (Math.PI / 180);
      spherical.phi = phi; // phi是方位面（水平面）内的角度，范围0~360度

      spherical.theta = theta; // theta是俯仰面（竖直面）内的角度，范围0~180度

      var position = new THREE.Vector3();
      position.setFromSpherical(spherical);
      return position;
    },
    // 创建地标标记
    createHexagon: function createHexagon(position) {
      var _this = this;

      this.hexagon = new THREE.Object3D();
      var hexagonPlane = new THREE.CircleGeometry(4, 7);
      var material = new THREE.MeshBasicMaterial({
        side: THREE.DoubleSide,
        transparent: true,
        map: new THREE.TextureLoader().load(require("../../assets/others/index/star.png")),
        opacity: 1
      });
      var circlePlane = new THREE.Mesh(hexagonPlane, material);
      circlePlane.position.copy(position);
      circlePlane.lookAt(new THREE.Vector3(0, 0, 0));
      this.hexagon.add(circlePlane);
      this.scene.add(this.hexagon);
      timer = setInterval(function () {
        _this.hexagon.visible = !_this.hexagon.visible;
      }, 500);
    },
    // 初始球体
    initSphere: function initSphere(x, y, z) {
      var geometry = new THREE.SphereGeometry(1, 100, 100); //球体几何

      var material = new THREE.MeshBasicMaterial({
        color: 0xffff00
      }); //网格基础材料

      var sphere = new THREE.Mesh(geometry, material);
      sphere.position.x = x;
      sphere.position.y = y;
      sphere.position.z = z;
      this.scene.add(sphere);
    },
    renderScene: function renderScene() {
      var deg = 0.07;
      this.deg += deg;

      if (this.deg <= 3.05) {
        // 自动旋转动画
        this.scene.rotateY(deg);
        this.scene.rotateZ(0.021);
      } else {
        var zValue = 5;
        this.zValue += zValue;
        this.scene.position.x -= 0.03;
        this.scene.position.z += zValue; // console.log('远近：',this.zValue)

        if (this.zValue > 450) {
          this.isAnimation = false;
          this.showEarth = false;
        }
      }

      if (this.isAnimation) {
        requestAnimationFrame(this.renderScene);
      }

      this.renderer.render(this.scene, this.camera);
    },
    confirm: function confirm() {
      localStorage.setItem('showEarth', 'false');
      this.flag = false;
      this.showEarth = false;
    },
    cancel: function cancel() {
      this.showEarth = false;
    }
  }
};